module.exports = "../content/2ffc058ddedacfeaa23542026c8108e2.ttf";